import { useMemo } from "react";
import { Trophy } from "lucide-react";
import { Empty, Section } from "./redeShared";
import { Stars, displayName } from "./shared";

export const RankingView = ({ leads, onOpen }) => {
  const ranked = useMemo(
    () =>
      leads
        .filter(
          (l) =>
            l.type === "partner" &&
            l.status === "parceria_fechada" &&
            Number(l.payload?.rating) > 0
        )
        .sort((a, b) => Number(b.payload.rating) - Number(a.payload.rating)),
    [leads]
  );

  return (
    <div data-testid="ranking-view">
      <h1 className="flex items-center gap-3 font-display text-2xl font-bold text-petrol sm:text-3xl">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand/10 text-brand">
          <Trophy className="h-5 w-5" />
        </span>
        Ranking de prestadores
      </h1>
      <p className="mt-1 text-sm text-slate-500">
        Os melhores avaliados da rede. A avaliação é feita na tela de Prestadores.
      </p>

      <Section
        title="Melhores avaliados"
        sub={`${ranked.length} prestador(es) com avaliação.`}
        testId="rede-ranking"
      >
        {ranked.length === 0 ? (
          <Empty>
            Nenhum prestador avaliado ainda. Defina as estrelas na tela de Prestadores para montar
            o ranking.
          </Empty>
        ) : (
          <ol className="space-y-2.5">
            {ranked.map((p, i) => (
              <li key={p.id}>
                <button
                  onClick={() => onOpen(p)}
                  data-testid={`rank-item-${p.id}`}
                  className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-brand/40 hover:shadow-md"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-display text-sm font-extrabold ${
                      i === 0
                        ? "bg-brand text-white"
                        : i < 3
                          ? "bg-brand/10 text-brand"
                          : "bg-slate-100 text-slate-500"
                    }`}
                  >
                    {i + 1}º
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-bold text-petrol">
                      {displayName(p)}
                    </span>
                    <span className="mt-0.5 block truncate text-xs text-slate-500">
                      {(p.payload?.specialties || []).slice(0, 4).join(", ")} ·{" "}
                      {(p.payload?.cities || []).slice(0, 3).join(", ")}
                    </span>
                  </span>
                  <span className="flex shrink-0 items-center gap-2">
                    <Stars value={Number(p.payload?.rating)} />
                    <span className="font-display text-sm font-bold text-petrol">
                      {Number(p.payload?.rating).toFixed(1)}
                    </span>
                  </span>
                </button>
              </li>
            ))}
          </ol>
        )}
      </Section>
    </div>
  );
};
